import { Popover, Chip } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import styles from "../Filters.module.scss";

interface FilterChipProps
  extends Pick<React.ComponentProps<typeof Chip>, "count" | "label"> {
  dropdownContent?: React.ReactNode;
  isActive: boolean;
  handleToggleChip: () => void;
  disableUserDismiss?: boolean;
  handleUserDismiss?: () => void;
}

const FilterChip = ({
  dropdownContent,
  isActive,
  handleToggleChip,
  count,
  label,
  disableUserDismiss = false,
  handleUserDismiss,
}: FilterChipProps) => {
  if (handleUserDismiss && !dropdownContent) {
    return (
      <div className={cc(styles.filterChipText, "margin--right--m")}>
        <Chip
          count={count}
          kind="secondary"
          label={label}
          // NDS prop to display the "x" icon
          onDismiss={handleUserDismiss}
        />
      </div>
    );
  }

  return (
    <div className={cc(styles.filterChipText, "margin--right--m")}>
      <Popover
        content={dropdownContent}
        isOpen={isActive}
        // for when user clicks outside the popover
        {...(!disableUserDismiss && {
          onUserDismiss: handleToggleChip,
        })}
      >
        <Chip
          count={count}
          kind="secondary"
          label={label}
          onClick={handleToggleChip}
          endIcon={`chevron-${isActive ? "up" : "down"}`}
        />
      </Popover>
    </div>
  );
};

export default FilterChip;
